import {CSS} from '@stitches/react';

export const cellHorizontalPadding = 6;

export const agRowSelectedBeforeCSS: CSS = {
	borderBottomStyle: 'solid',
	borderBottomColor: '$primaryHighlight',
	borderBottomWidth: 1,
};
